<template>
  <div class="outer-wrapper">
    <div class="container">
      <h1 class="text-4xl text-white md:text-4xl lg:text-5xl pt-10 text-center">
        INSIGHTS
      </h1>
      <div class="image-container">
        <img
          class="manzdev"
          src="@/assets/images/foundation1.jpg"
          alt="ManzDev"
        />
        <div class="gradient"></div>
      </div>
      <img
        src="../assets/images/foundation2.jpg"
        alt="tailwind"
        class="tailwind"
      />
      <img
        src="../assets/images/foundation8.jpg"
        alt="css"
        class="css"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "InsightsView",
};
</script>

<style lang="scss" scoped>
body {
  background: #225;
}

.outer-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: black; 
  padding: 1rem;
}

.container {
  display: grid;
  place-items: center;
  height: 97vh;
  position: relative;
  overflow: hidden;
  isolation: isolate;
}

.image-container {
  --size: 320px;
  
  width: var(--size);
  height: var(--size);
  background: linear-gradient(rgb(24, 24, 72), orange);
  border: 15px solid #fff;
  border-bottom-width: 50px;
  box-shadow: 6px 6px 15px #0008;
  rotate: -5deg;
  user-select: none;
  overflow: hidden;
  position: relative;
  z-index: 10;
}

.manzdev {
  rotate: -6deg;
  translate: 0 20px;
  filter: drop-shadow(6px 0 4px #0006);
}

:is(.gradient, .manzdev, .css, .tailwind) {
  position: absolute;
}

.gradient {
  background: radial-gradient(rgb(16, 10, 75), black);
  mix-blend-mode: screen;
  width: 100%;
  height: 100%;
}

.manzdev {
  animation: move 3s infinite alternate;
}

@keyframes move {
  0%,
  50% {
    translate: 0 20px;
  }
  75%,
  100% {
    translate: 0 350px;
  }
}

:is(.css, .tailwind) {
  width: 256px;
  z-index: 1;
}

.css {
  animation: left-appears 6s infinite alternate 3s;
  rotate: -8deg;
}

.tailwind {
  animation: right-appears 6s infinite alternate;
}

@keyframes right-appears {
  50%,
  75% {
    translate: 300px 0;
  }
}

@keyframes left-appears {
  50%,
  75% {
    translate: -260px 25px;
  }
}

/* Responsive Design */
@media (max-width: 768px) {
  .container {
    padding: 0 1rem;
    height: 100vh;
  }
  
  .image-container {
    --size: 250px;
    border-width: 10px;
    border-bottom-width: 35px;
  }
  
  :is(.css, .tailwind) {
    width: 180px;
  }
  
  @keyframes move {
    0%,
    50% {
      translate: 0 15px;
    }
    75%,
    100% {
      translate: 0 250px;
    }
  }
  
  @keyframes right-appears {
    50%,
    75% {
      translate: 200px 0;
    }
  }
  
  @keyframes left-appears {
    50%,
    75% {
      translate: -180px 20px;
    }
  }
}

@media (max-width: 480px) {
  .container {
    height: 100vh;
  }
  
  .image-container {
    --size: 200px;
    border-width: 8px;
    border-bottom-width: 25px;
  }
  
  :is(.css, .tailwind) {
    width: 140px;
  }
  
  @keyframes move {
    0%,
    50% {
      translate: 0 10px;
    }
    75%,
    100% {
      translate: 0 200px;
    }
  }
  
  @keyframes right-appears {
    50%,
    75% {
      translate: 150px 0;
    }
  }
  
  @keyframes left-appears {
    50%,
    75% {
      translate: -140px 15px;
    }
  }
}

@media (max-width: 320px) {
  .image-container {
    --size: 170px;
    border-width: 6px;
    border-bottom-width: 20px;
  }
  
  :is(.css, .tailwind) {
    width: 120px;
  }
  
  @keyframes move {
    0%,
    50% {
      translate: 0 8px;
    }
    75%,
    100% {
      translate: 0 170px;
    }
  }
  
  @keyframes right-appears {
    50%,
    75% {
      translate: 120px 0;
    }
  }
  
  @keyframes left-appears {
    50%,
    75% {
      translate: -120px 12px;
    }
  }
}

@media (min-width: 1200px) {
  .image-container {
    --size: 400px;
    border-width: 20px;
    border-bottom-width: 60px;
  }
  
  :is(.css, .tailwind) {
    width: 320px;
  }
  
  @keyframes move {
    0%,
    50% {
      translate: 0 25px;
    }
    75%,
    100% {
      translate: 0 450px;
    }
  }
  
  @keyframes right-appears {
    50%,
    75% {
      translate: 400px 0;
    }
  }
  
  @keyframes left-appears {
    50%,
    75% {
      translate: -320px 30px;
    }
  }
}
</style>